import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mobile } from "../../responsive";
import swal from "sweetalert";
import PropagateLoader from "react-spinners/PropagateLoader";
import styled from "styled-components";
import useAuth from "./../../auth/useAuth";
import apiClient from "./../../api/client";

const Login = () => {
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [uploadVisible, setUploadVisible] = useState(false);
  const navigate = useNavigate();
  const { logIn } = useAuth();

  function handleChange(event) {
    const { name, value } = event.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  }

  const handleSubmit = async (e) => {
    setUploadVisible(true);
    e.preventDefault();
    const result = await apiClient.post("/admin/login", {
      email: state.email,
      password: state.password,
    });
    if (result.ok) {
      setUploadVisible(false);

      swal("Login Success");
      logIn(result.data.token);
      navigate("/");
    } else {
      setUploadVisible(false);
      swal("Login Error Retry");
    }
  };

  return (
    <Container>
      {uploadVisible ? (
        <PropagateLoader color="rgba(54, 215, 183, 1)" size={30} />
      ) : (
        <Wrapper>
          <Title>SIGN IN</Title>
          <Form>
            <Input
              placeholder="Email Address"
              name="email"
              onChange={handleChange}
            />
            <Input
              placeholder="Password"
              name="password"
              type={"password"}
              onChange={handleChange}
            />
            <Button onClick={handleSubmit}>LOGIN</Button>
          </Form>
        </Wrapper>
      )}
    </Container>
  );
};
const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.2)
  ),
  url("https://cdn4.vectorstock.com/i/1000x1000/14/68/travel-and-tourism-background-vector-2651468.jpg") center;
background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
`;

const Wrapper = styled.div`
  width: 35%;
  height: 40%;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  ${mobile({ width: "75%" })}
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  padding-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: black;
  color: white;
  cursor: pointer;
  border-radius: 15px;
  margin: 0 auto;
  margin-top: 20px;
`;

const Link = styled.a`
  /* margin: 25px 0px; */
  font-size: 17px;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
  margin-top: 40px;
  color: black;
`;

export default Login;
